import { useState } from "react";
import { faqs } from "@/mocks/animes";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="border-y border-background-200/70 bg-background-100/70">
      <div className="mx-auto max-w-3xl px-4 py-14 md:px-6 md:py-16">
        <div className="mb-8 text-center">
          <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            你可能想问
          </h2>
          <p className="mt-2 text-sm text-foreground-600">关于片单、选番和追更，一次说清楚。</p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg bg-background-50 border border-background-200/70"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">
                    {f.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-base"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}